import { useEffect, useState } from 'react';

// Sicheres Parsen von JSON, robust gegen alles
function safeJson(str, fallback = []) {
  if (Array.isArray(str) || typeof str === "object") return str;
  try {
    if (!str || (typeof str === "string" && str.trim() === "")) return fallback;
    return JSON.parse(str);
  } catch (e) {
    console.warn("Fehler beim Parsen von JSON (safeJson im Hook):", str, e);
    return fallback;
  }
}

// NEU: Nur noch registrationId!
const useUserCourseMaterials = (registrationId) => {
  const [materials, setMaterials] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!registrationId) {
      setLoading(false);
      setError("Registration ID fehlt.");
      return;
    }

    const url = `https://www.denisbitter.de/stage01/api/get_user_course_materials.php?registrationId=${registrationId}`;

    setLoading(true);
    setError(null);

    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP-Fehler: ${res.status} ${res.statusText}`);
        return res.json();
      })
      .then(data => {
        if (data.success && data.data) {
          const raw = data.data;
          // Debug-Ausgabe
          console.log("RAW:", raw);
          console.log("Typ video_links:", typeof raw.video_links, raw.video_links);
          console.log("Typ day_plan_json:", typeof raw.day_plan_json, raw.day_plan_json);

          const parsed = {
            ...raw,
            video_links: safeJson(raw.video_links, []),
            day_plan_json: safeJson(raw.day_plan_json, {}),
          };

          setMaterials(parsed);
        } else {
          setError(data.message || "Keine Kursmaterialien gefunden.");
          setMaterials(null);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Fehler beim Laden der Kursmaterialien:", err);
        setError(err.message);
        setLoading(false);
        setMaterials(null);
      });
  }, [registrationId]);

  return { materials, loading, error };
};

export default useUserCourseMaterials;
